import { Component } from '@angular/core';

import { MenuOutletComponent } from '../menu-outlet/menu-outlet.component';

@Component({
    selector: 'soft-responsive-menu',
    imports: [MenuOutletComponent],
    template: '<soft-menu-outlet class="flex-row flex-nowrap justify-center items-center" name="responsive"></soft-menu-outlet>',
    styleUrl: './responsive-menu.component.css'
})
export class ResponsiveMenuComponent {}
